import { ReactNode } from 'react'
import { FieldValues, FormProvider, UseFormReturn } from 'react-hook-form'
import styled from 'styled-components'

// Note: a fixed width sizes the popup (a percentage width would let wrapping content, like the icon
// picker, size it as one long line); min-width fills the popup when its footer is wider than the form
const Container = styled.div<{ $width: string }>(({ $width }) => ({
  minWidth: '100%',
  width: $width,
}))

const StyledForm = styled.form(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
}))

interface PersonFormLayoutProps<T extends FieldValues> {
  children: ReactNode
  form: UseFormReturn<T>
  onSubmit: () => void
  width?: string
}

export const PersonFormLayout = <T extends FieldValues>({
  children,
  form,
  onSubmit,
  width = '52rem',
}: PersonFormLayoutProps<T>) => (
  <Container $width={width}>
    <FormProvider {...form}>
      <StyledForm onSubmit={onSubmit}>{children}</StyledForm>
    </FormProvider>
  </Container>
)
